export default __webpack_public_path__ + "static/media/rnd-card2-2.367fb214.png";